import api from './api';
import type { NotificationGroup, Notification } from '@app-types/models/chat';

export const getNotificationGroupByType = async (): Promise<NotificationGroup[]> => {
  const response = await api.get<NotificationGroup[]>('/chat/notification-by-type');
  return response.data;
};

export const getNotificationsByType = async (type: string): Promise<Notification[]> => {
  const response = await api.get<Notification[]>(`/chat/notifications/${type}`);
  return response.data;
};

export const markNotificationAsRead = async (type: string): Promise<unknown> => {
  const response = await api.post<unknown>(`/chat/mark-notifications-as-read/${type}`);
  return response.data;
};
